import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { PricingProfileAction } from '../pricingProfile.action';
import { PricingProfileTranslator } from '../pricingProfile.translator';

type IDependencies = IClientApiDependencySegment;

export const createPricingProfileEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(PricingProfileAction.create.started),
  mergeMap((params) => {
    const { reject } = params;
    const apiPayload = PricingProfileTranslator.toApi(params);

    return dependencies.api.createPricingProfile(apiPayload).pipe(
      mergeMap((result) => {
        const cleanedProfileWithId = {
          ...params,
          id: result.id,
        };

        return [
          PricingProfileAction.create.done({ params: cleanedProfileWithId }),
          DetailsSidebarAction.close(),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          PricingProfileAction.create.failed({ params, error }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
